export const getAllParentCategoriesList = () => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/parentCategory/get/all`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at getting parent Categories list ${e}`));
};

export const CreateParentCaregory = body => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/parentCategory/create`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at Create parent category ${e}`));
};

export const UpdateParentCategory = (body,id) => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/parentCategory/update/${id}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at update parent category ${e}`));
};

export const deleteParentCategory = id => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/parentCategory/delete/${id}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at deleting parent category ${e}`));
};
